export const RAW_RETURN_SUM_LABEL = 'Raw return sum';
export const WINSORIZED_RETURN_SUM_LABEL = 'Winsorized return sum';
export const RAW_RETURN_SUM_DESCRIPTION =
    'Arithmetic sum of raw return percentages for passing signals; it is not compounded and does not represent a portfolio return or position-sized dollar P&L.';
